module.exports = __webpack_public_path__ + "img/whats-new-mobile_jp.556de07.jpg";